import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
import { useAtomValue } from 'jotai';
import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { CompanyFinanceRoundsState } from '../../CompanyProfiles/state/CompanyFundingsState';
import { selectedCompanyIdProfileAtom } from '../../CompanyProfiles/state/UIStateJ';
import { CompanyDealsView } from './CompanyDealsView';

const loadingCss = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

function DealsLoadingFallback() {
  return (
    <div css={loadingCss}>
      <Skeleton variant='rectangular' width={360} height={96} />
      <Skeleton variant='rectangular' width={360} height={96} />
      <Skeleton variant='rectangular' width={360} height={96} />
    </div>
  );
}

function DealsTabContent({ companyId }: { companyId: number }) {
  const rounds = useAtomValue(CompanyFinanceRoundsState(companyId));
  return <CompanyDealsView rounds={rounds} companyId={companyId} />;
}

/**
 * Deals tab for the company profile — a master-detail view of the company's
 * financing rounds and their deal documents.
 */
export function DealsTab() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);

  return (
    <GenericFallbacksWrapper suspenseFallback={<DealsLoadingFallback />}>
      <DealsTabContent companyId={companyId} />
    </GenericFallbacksWrapper>
  );
}
